import { render } from "./ClassRecordsContainer.vue?vue&type=template&id=8df37f4c&scoped=true&ts=true"
import script from "./ClassRecordsContainer.vue?vue&type=script&lang=ts"
export * from "./ClassRecordsContainer.vue?vue&type=script&lang=ts"

import "./ClassRecordsContainer.vue?vue&type=style&index=0&id=8df37f4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8df37f4c"]])

export default __exports__